export const AUTH_SESSION_KEY = 'auth:session';

export type AuthRequestConfig = {
  requestPathname?: string;
};

export function isSilentLoginUnauthorized(requestPathname: string | undefined): boolean {
  return requestPathname === '/login';
}

export function broadcastAuthSession(): void {
  try {
    localStorage.setItem(AUTH_SESSION_KEY, crypto.randomUUID());
  } catch {
    // Safari private mode can throw QuotaExceededError
  }
}

export function loginRedirect(
  search: string = window.location.search,
  origin: string = window.location.origin,
): string {
  const redirect = new URLSearchParams(search).get('redirect') ?? '/';
  try {
    const url = new URL(redirect, origin);
    if (url.origin !== origin) return '/';
    const path = `${url.pathname}${url.search}${url.hash}`;
    if (!path.startsWith('/') || path.startsWith('//')) return '/';
    if (decodeURIComponent(url.pathname).startsWith('//')) return '/';
    return path;
  } catch {
    return '/';
  }
}
